export default (theme) => ({
  root: {
    background: '#fcfbfc',
    borderRadius: 3,
    marginTop: 16,
    marginBottom: 16,
    padding: 15,
  },
  title: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: 16,
    fontSize: 12,
    color: '#a5a5a5',
  },
  filterContainer: {
    '& > div': {
      marginRight: 8,
      marginBottom: 8,
    },
  },
});
